import React from 'react'
import { PencilSimple, Trash } from '@phosphor-icons/react'
import { capitalizeFirstLetter } from 'helper/utility'
import { DivisonListingResp } from 'types/league/division'
import maleIcon from 'assets/Images/maleIcon.svg'
import femaleIcon from 'assets/Images/femaleIcon.svg'
import coedIcon from 'assets/Images/coedIcon.svg'

const genderIcons: Record<string, string> = {
  male: maleIcon,
  female: femaleIcon,
  coed: coedIcon,
}

interface DivisionProps {
  item: DivisonListingResp
  handleDeleteDivsion: (division: DivisonListingResp) => void
  handleManageDivision: (division: DivisonListingResp) => void
}

const Division: React.FC<DivisionProps> = ({
  item,
  handleDeleteDivsion,
  handleManageDivision,
}) => {
  return (
    <div className="flex align-center flex-col justify-between gap-20px px-10px py-10px radius-16 shadow mt-20px w-90p mx-auto">
      <div className="flex align-center gap-20px justify-between w-full">
        <div className="flex align-center gap-10px w-full">
          <div className="border-1px radius-12 py-20px px-20px">
            <img
              src={genderIcons[item.genders?.[0] ?? ''] ?? coedIcon}
              alt="gender-icon"
              className="w-40px h-40px"
            />
          </div>
          <div className="flex-1">
            <div className="flex align-center justify-between gap-10px mb-10px">
              <h3>{item.name ? capitalizeFirstLetter(item.name) : ``}</h3>
              <p className="text-gray">
                ${item.price ? item.price.toFixed(2) : '0.00'}
              </p>
            </div>

            <div className="flex gap-10px flex-wrap">
              {item.genders?.map((gender, index) => (
                <div
                  key={`gender-${index}`}
                  className="flex align-center justify-center gap-10px bg-grey py-5px px-5px radius-16 w-fit"
                >
                  <p>{capitalizeFirstLetter(gender)}</p>
                </div>
              ))}

              {item.ageGroups?.map((ageGroup, index) => (
                <div
                  key={`age-${index}`}
                  className="flex align-center justify-center gap-10px bg-grey py-5px px-5px radius-16 w-fit"
                >
                  <p>{ageGroup.name}</p>
                </div>
              ))}

              {item.skillLevels?.map((skillLevel, index) => (
                <div
                  key={`skill-${index}`}
                  className="flex align-center justify-center gap-10px bg-grey py-5px px-5px radius-16 w-fit"
                >
                  <p>{skillLevel.name}</p>
                </div>
              ))}

              {item.regions?.map((region, index) => (
                <div
                  key={`region-${index}`}
                  className="flex align-center justify-center gap-10px bg-grey py-5px px-5px radius-16 w-fit"
                >
                  <p>{region}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      <div className="flex align-center justify-between mt-5px border-top w-full pt-10px px-20px">
        <button
          className="flex align-center justify-center gap-10px btn-danger"
          onClick={() => handleDeleteDivsion(item)}
        >
          <Trash className="pointer" size={20} color="#ff6961" />
          <span>Delete</span>
        </button>
        <h3
          className="text-prim text-15 w-600 pointer"
          onClick={() => handleManageDivision(item)}
        >
          Manage division
        </h3>
      </div>
    </div>
  )
}

export default Division
